<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">
            {{ accountSubscription.name }}
          </h4>

          <div class="flex md:ml-auto mt-4 md:mt-0">
            <BaseButton
              v-if="$membershipHasPermissionTo('create account subscriptions')"
              tag="router-link"
              :to="{
                name: 'accounts.accountSubscriptions.accountSubscriptionUuid.edit',
                params: {
                  accountId,
                  accountSubscriptionUuid,
                },
              }"
              primary
              class="ml-auto md:ml-4"
            >
              Edit
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <div class="p-4 lg:p-12">
      <div class="max-w-5xl mx-auto">
        <nav class="border-b-2 border-gray-400">
          <RouterLink
            :to="{
              name: 'accounts.accountSubscriptions.accountSubscriptionUuid',
              params: {
                ...$route.params,
              },
            }"
            class="font-medium py-3 border-b-2 border-gray-400 text-gray-500 inline-block -mb-2px hover:border-gray-700 hover:text-gray-700"
            exact-active-class="border-blue-700 text-gray-900"
          >
            Details
          </RouterLink>
          <RouterLink
            :to="{
              name: 'accounts.accountSubscriptions.accountSubscriptionUuid.subscriptionOrders',
              params: {
                ...$route.params,
              },
            }"
            class="font-medium py-3 border-b-2 border-gray-400 text-gray-500 inline-block ml-4 -mb-2px hover:border-gray-700 hover:text-gray-700"
            exact-active-class="border-blue-700 text-gray-900"
          >
            Subscription Orders
          </RouterLink>
        </nav>
        <div class="mt-12">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { middleware } from '@/routes/guards';
import store from '@/store';

export default {
  name: 'AccountAccountSubscriptionPage',

  props: {
    accountId: {
      type: String,
      required: true,
    },
    accountSubscriptionUuid: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters('ui/accountSubscriptions', ['accountSubscription']),
  },

  beforeRouteEnter(to, from, next) {
    const { accountSubscriptionUuid } = to.params;
    const { query } = to;
    const check = middleware('account-permission:read account subscriptions');

    check(to, from, async (...args) => {
      try {
        if (args.length) {
          return next(...args);
        }
        await store.dispatch('ui/accountSubscriptions/read', {
          accountSubscriptionUuid,
          params: { ...query, include: 'agency,membershipProduct' },
        });
        return next();
      } catch (error) {
        return next(false);
      }
    });
  },
};
</script>
